
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.625.43a.889.889 0 00-.597.292L14.222 25.833 1.972 13.167a.889.889 0 10-1.278 1.222l12.89 13.333a.889.889 0 001.277 0L39.306 1.944a.889.889 0 00-.681-1.513z","fill":"#32383D","fill-rule":"evenodd"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/check.svg